import React from 'react';
import { Chart } from 'primereact/chart';
import { Card } from 'primereact/card';

export default function CreditScoreDoughnut({ score, min = 0, max = 850 }) {

    const rawScore = Number(score);
    const isValidScore = Number.isFinite(rawScore);
    const clampedScore = isValidScore ? Math.min(Math.max(rawScore, min), max) : min;
    const percentage = ((clampedScore - min) / (max - min)) * 100;

    const minColor = '#E74C3C'; // rojo cálido
    const maxColor = '#23b56e'; // verde
    const fallbackColor = '#34b9e0';

    const isAtMin = clampedScore === min;
    const isAtMax = clampedScore === max;

    const doughnutData = {
        labels: ['Score', 'Restante'],
        datasets: [
            {
                data: [percentage, 100 - percentage],
                backgroundColor: (context) => {
                    const chart = context.chart;
                    const chartArea = chart?.chartArea;
                    const canvasCtx = chart?.ctx;

                    if (context.dataIndex !== 0) return '#e0e0e0';
                    if (isAtMin) return minColor;
                    if (isAtMax) return maxColor;

                    if (!chartArea || !canvasCtx) return fallbackColor;

                    const gradient = canvasCtx.createLinearGradient(chartArea.left, 0, chartArea.right, 0);
                    gradient.addColorStop(0, minColor);
                    gradient.addColorStop(1, maxColor);
                    return gradient;
                },
                borderWidth: 0,
                borderRadius: 10
            }
        ]
    };

    const doughnutOptions = {
        rotation: -90,
        circumference: 180,
        cutout: '70%',
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { display: false },
            tooltip: { enabled: false }
        }
    };

    const scoreTextColor = isAtMin ? minColor : isAtMax ? maxColor : fallbackColor;

    return (

        <Card
            className="shadow-2 border-round-lg"
            style={{
                height: '183px',
                backgroundColor: '#ffffff',
                width: '90%',
                margin: "auto",
                position: 'relative',
                padding: '0 1.5rem',
            }}
            bodyStyle={{
                padding: '0'
            }}
        >
            {/* Título como las otras cards */}
            <div className="text-sm text-blue-500 font-medium mb-3">Score de crédito</div>

            {/* Gráfico centrado con número grande en medio */}
            <div style={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Chart
                    style={{ height: '100px', width: '100%' }}
                    type="doughnut" 
                    data={doughnutData} 
                    options={doughnutOptions} 
                />

                {/* Número grande centrado */}
                <div style={{
                    position: 'absolute',
                    bottom: '15px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    fontSize: '2rem',
                    fontWeight: 700,
                    color: scoreTextColor,
                    textShadow: '0 1px 2px rgba(0, 0, 0, 0.15)'
                }}>
                    {isValidScore ? rawScore : '-'}
                </div>

                {/* Etiqueta mínimo */}
                <div style={{
                    position: 'absolute',
                    bottom: '100px',
                    left: '15px',
                    fontSize: '0.85rem',
                    color: '#999',
                    fontWeight: 500,
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px'
                }}>
                    {min}
                </div>

                {/* Etiqueta máximo */}
                <div style={{
                    position: 'absolute',
                    bottom: '100px',
                    right: '15px',
                    fontSize: '0.85rem',
                    color: '#999',
                    fontWeight: 500,
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px'
                }}>
                    {max}
                </div>
            </div>
        </Card>
    );
}
